module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABnSURBVHgB7ZJLCsAgDESHnqwHSA/QO3un1EAXWWhMVBDBB9n4eSFkgMMeMPOb6zbuSd4gIHxyJflYkSWroVuqZIQetHRYVpC6ZBfaMGahx7QWFZapsz6pRMKITVz6B5saDf3BPqzlA8ripb3e0iOxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 2